// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.identification-box[data-v-35a4a47d] {\n  margin-top: 1.5rem;\n}\n.actions[data-v-35a4a47d] {\n  display: flex;\n  margin-bottom: 1.5rem;\n}\n.actions > .ui-toggle[data-v-35a4a47d] {\n  margin-right: auto;\n}\n.actions > .ui-button + .ui-button[data-v-35a4a47d] {\n  margin-left: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
